@if (showCheck) {
  <app-lu-icon class="green" icon="check-complete"></app-lu-icon>
}
@if (showX) {
  <app-lu-icon  class="red" icon="x-octagon"></app-lu-icon>
}

{{ statusText }}

@if (badgeOnly) {
  <ng-content></ng-content>
}
